import { render } from "./LocatorAttributes.vue?vue&type=template&id=197a8e90&scoped=true&ts=true"
import script from "./LocatorAttributes.vue?vue&type=script&lang=ts"
export * from "./LocatorAttributes.vue?vue&type=script&lang=ts"

import "./LocatorAttributes.vue?vue&type=style&index=0&id=197a8e90&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197a8e90"]])

export default __exports__